import { IconBase, IconBaseProps } from "./IconBase";

export const AlertIcon = (props: IconBaseProps) => {
  const fill = props.color ?? "currentColor";

  return (
    <IconBase {...props} viewBox="0 0 16 16">
      <path
        d="M7.44621 10.2222C7.44621 9.91543 7.69494 9.66669 8.00176 9.66669H8.00704C8.31387 9.66669 8.5626 9.91543 8.5626 10.2222C8.5626 10.5291 8.31387 10.7778 8.00704 10.7778H8.00176C7.69494 10.7778 7.44621 10.5291 7.44621 10.2222Z"
        fill={fill}
        stroke="none"
      />
      <path
        d="M8.55732 5.7778C8.55732 5.47098 8.30859 5.22225 8.00176 5.22225C7.69494 5.22225 7.44621 5.47098 7.44621 5.7778V8.00003C7.44621 8.30685 7.69494 8.55558 8.00176 8.55558C8.30859 8.55558 8.55732 8.30685 8.55732 8.00003V5.7778Z"
        fill={fill}
        stroke="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.89062 8.00003C1.89062 4.62495 4.62666 1.88892 8.00174 1.88892C11.3768 1.88892 14.1128 4.62495 14.1128 8.00003C14.1128 11.3751 11.3768 14.1111 8.00174 14.1111C4.62666 14.1111 1.89062 11.3751 1.89062 8.00003ZM8.00174 3.00003C5.24031 3.00003 3.00174 5.2386 3.00174 8.00003C3.00174 10.7615 5.24031 13 8.00174 13C10.7632 13 13.0017 10.7615 13.0017 8.00003C13.0017 5.2386 10.7632 3.00003 8.00174 3.00003Z"
        fill={fill}
        stroke="none"
      />
    </IconBase>
  );
};
